module.exports = __webpack_public_path__ + "static/media/turn-signal.3b58c6d4.jpg";